// extracted by mini-css-extract-plugin
export default {"city":"styles_city__q3hLM","truncate":"styles_truncate__s1xly","headerWidth":"styles_headerWidth__XiUZE","textWidth":"styles_textWidth__QmRhl"};